// ─────────────────────────────────────────────────────────────────────────────
// 🚨 THE FOUR SELF-EMPLOYED INCOME PATHS, ONCE.
//
// Jesse: "set Mario's self-employed path and have her try again."
//
// 🔑 THERE WERE FOUR PLACES THAT KNEW THIS LIST and no single definition: the
// borrower's picker in Verification.js, the whitelist in routes/users.js, the
// new staff whitelist in routes/admin.js, and the staff select on the borrower
// profile. The id strings are load-bearing — routes/readycheck.js branches on
// `path === 'full_doc_sole' || path === 'full_doc_scorp'` to decide whether a
// 1040 or a YTD P&L may be asked for — so a fifth spelling anywhere makes
// ReadyCheck read a path no prompt branch describes.
//
// ⚠️ THIS CODEBASE KEEPS FINDING THAT SHAPE. Four definitions of
// eva_feedback_surface_chk (the last one to run dropped a surface), four lead
// drawer gutters, two definitions of "the same need", two alert-table column
// vocabularies. A list copied per call site is a list that drifts.
//
// ⚠️ THE BACKEND WHITELISTS STAY WHERE THEY ARE. They are server-side
// validation and must not import from frontend/, so they are checked AGAINST
// this file by test/selfEmployedPathStaffEdit.js rather than sharing it — the
// assertion is the join, which is the most a test can do across that boundary.
// ─────────────────────────────────────────────────────────────────────────────

/**
 * 🔑 THE BORROWER-FACING WORDING LIVES HERE TOO, so staff and borrower are
 * choosing from the same list and mean the same thing by it. Staff renders the
 * label; the borrower's picker renders label + desc.
 */
export const pathOptions = [
  // 🚨 ADDED BECAUSE THE 1099 PATH WAS NOT CHOOSABLE. uwSystemPrompt's Path A
  // has always been documented, priced and asked for — "2 years 1099-NEC or
  // 1099-MISC from all payors + 12 months personal or business bank statements"
  // — and the four options below map to its Path C and Path B only. A 1099
  // contractor had no way to say "document me on my 1099s", so the rule guessed
  // from employment type and asked a borrower who had lost his forms for them.
  // Listed first because it is the one a contractor is looking for.
  { id: 'path_1099', label: '1099 / Contract Income Path', desc: 'Your prior-year 1099 plus proof of this year\'s income (a paystub, a written verification of employment, or equivalent). No tax returns used on this path.' },
  { id: 'full_doc_sole', label: 'Sole Proprietor — Full Doc', desc: 'You file Schedule C on your personal taxes. Requires your most recent year of personal tax returns and 2 months of bank statements.' },
  { id: 'full_doc_scorp', label: 'Partnership / S-Corp — Full Doc', desc: 'You own ≥25% of a partnership or S-Corp. Requires your most recent year of personal and business tax returns and 2 months of bank statements.' },
  { id: 'bank_stmt_personal', label: 'Personal Bank Statement Program', desc: '12 or 24 months of personal bank statements. No tax returns used on this path.' },
  { id: 'bank_stmt_business', label: 'Business Bank Statement Program', desc: '12 or 24 months of business bank statements. No tax returns used on this path.' },
];

/**
 * ⚠️ ONLY THESE TWO PERMIT A 1040 OR A YTD P&L. uwSystemPrompt's PATH-AWARE
 * 1040 RULE and the scrubber in routes/readycheck.js both turn on this
 * distinction, and an unset path is treated as bank-stmt by default — which is
 * why Mario's file was asked for both while having neither.
 */
export const FULL_DOC_PATHS = ['full_doc_sole', 'full_doc_scorp'];
